import React from 'react'
import CloseIcon from '@mui/icons-material/Close';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import "../../css/dialog.css"

export default function Warning(props) {
	const handleClose = (event, reason) => {
		if (reason && reason === "backdropClick") {
			return;
		}
		props.onHideWarning(false);
	}

	return (
		<>
			<Dialog
				open={props.open}
				onClose={handleClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
				// onKeyUp = {(e) => {
				// 	if (e.key === 'Enter') {
				// 		handleClose();
				// 	}
				// }}
				sx={{
					"& .MuiDialog-container": {
						"& .MuiPaper-root": {
							maxWidth: "none",
							fontFamily: "meiryo",
						},
					},
					padding: "0px",
				}}
			>
				{/* 경고 */}
				<DialogTitle id="alert-dialog-title" style={{ fontWeight: "bold", borderBottom: "solid 1px #928a97", padding: "3px 20px", backgroundColor: "rgb(45, 55, 72)", color: "white", fontSize: "25px" }}>
					경고 <CloseIcon onClick={handleClose} style={{ float: "right", marginTop: "5px" }} />
				</DialogTitle>
				<DialogContent>
					<div style={{ margin: "30px 50px 0px 50px", fontWeight: "bold" }}>
						{props.warningMsg}
					</div>
				</DialogContent>
				<div className='buttonGroup'>
					{/* 확인 */}
					<button className='dialogButton' onClick={handleClose}>
						확인
					</button>
				</div>
			</Dialog>
		</>
	)
}
